var _path, _path2, _path3, _path4, _path5, _path6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotifications(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6268 18.9796H10.3742C9.86214 18.9796 9.50228 19.4004 9.49951 19.8516H14.5043C14.4988 19.4004 14.1389 18.9796 13.6268 18.9796Z",
    fill: "url(#paint0_linear_1584_67784)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6268 18.9796H10.3742C9.86214 18.9796 9.50228 19.4004 9.49951 19.8516H14.5043C14.4988 19.4004 14.1389 18.9796 13.6268 18.9796Z",
    fill: "url(#paint1_linear_1584_67784)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6621 14.8662L18.5652 14.7665V11.1264C18.5652 8.38316 16.9597 6.03855 14.676 4.99219C14.5791 3.54722 13.4109 2.39844 12.002 2.39844C10.593 2.39844 9.42481 3.54445 9.32792 4.99219C7.04144 6.03855 5.43591 8.38316 5.43591 11.1264V14.7665L5.33903 14.8662C4.12381 15.9623 3.49268 17.4101 3.49268 19.1042C3.49268 19.5028 3.83316 19.8516 4.2207 19.8516H9.49678C9.49955 19.3976 9.85941 18.9796 10.3715 18.9796L13.6268 18.9796C14.1389 18.9796 14.4988 19.4004 14.5016 19.8516H19.7777C20.168 19.8516 20.5057 19.5028 20.5057 19.1042V18.9049C20.4614 17.2606 19.8275 15.9125 18.6621 14.8662Z",
    fill: "url(#paint2_linear_1584_67784)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6621 14.8662L18.5652 14.7665V11.1264C18.5652 8.38316 16.9597 6.03855 14.676 4.99219C14.5791 3.54722 13.4109 2.39844 12.002 2.39844C10.593 2.39844 9.42481 3.54445 9.32792 4.99219C7.04144 6.03855 5.43591 8.38316 5.43591 11.1264V14.7665L5.33903 14.8662C4.12381 15.9623 3.49268 17.4101 3.49268 19.1042C3.49268 19.5028 3.83316 19.8516 4.2207 19.8516H9.49678C9.49955 19.3976 9.85941 18.9796 10.3715 18.9796L13.6268 18.9796C14.1389 18.9796 14.4988 19.4004 14.5016 19.8516H19.7777C20.168 19.8516 20.5057 19.5028 20.5057 19.1042V18.9049C20.4614 17.2606 19.8275 15.9125 18.6621 14.8662Z",
    fill: "url(#paint3_linear_1584_67784)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.64606 20.3415C10.1554 21.1 11.0191 21.5983 11.999 21.5983C12.9789 21.5983 13.8426 21.1 14.3519 20.3415C14.4571 20.1865 14.5014 20.0177 14.5014 19.8516H9.49658C9.49658 20.0177 9.54364 20.1865 9.64606 20.3415Z",
    fill: "#15AAC7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8769 14.7007C11.465 14.7007 11.127 14.3957 11.127 14.0241V10.3772C11.127 10.0057 11.465 9.70068 11.8769 9.70068C12.2888 9.70068 12.6269 10.0057 12.6269 10.3772V14.022C12.6293 14.3957 12.2912 14.7007 11.8769 14.7007Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1584_67784",
    x1: 11.9992,
    y1: 2.39844,
    x2: 11.9992,
    y2: 19.8516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3FFFBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#33D69C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1584_67784",
    x1: 3.49268,
    y1: 19.561,
    x2: 21.1606,
    y2: 2.9537,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009CC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6ADEDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1584_67784",
    x1: 11.9992,
    y1: 2.39844,
    x2: 11.9992,
    y2: 19.8516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3FFFBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#33D69C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1584_67784",
    x1: 3.49268,
    y1: 19.561,
    x2: 21.1606,
    y2: 2.9537,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009CC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6ADEDB"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifications);
export default __webpack_public_path__ + "static/media/notifications.02107e49b01b129ae35fa05317f6a705.svg";
export { ForwardRef as ReactComponent };